import { Instagram, Facebook, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { trackContact } from "@/lib/tracking";

export default function Footer({ brand, footer }) {
  const offices = footer?.offices || [];
  const socials = footer?.socials || {};
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-ivory">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="font-display text-3xl md:text-4xl tracking-tight">{brand?.name || "Weddings by Mostash"}</div>
            <p className="mt-3 italic font-display text-gold text-lg md:text-xl">{footer?.tagline || "Planning Weddings Since 2016"}</p>
            <p className="mt-6 text-ivory/65 font-light max-w-sm leading-relaxed">
              A boutique wedding planning atelier. Destination, luxury, and intimate weddings across India and beyond.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socials.instagram ? (
                <a href={socials.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="h-10 w-10 inline-flex items-center justify-center border border-ivory/25 hover:bg-ivory hover:text-charcoal transition-colors">
                  <Instagram className="h-4 w-4" strokeWidth={1.4} />
                </a>
              ) : null}
              {socials.facebook ? (
                <a href={socials.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="h-10 w-10 inline-flex items-center justify-center border border-ivory/25 hover:bg-ivory hover:text-charcoal transition-colors">
                  <Facebook className="h-4 w-4" strokeWidth={1.4} />
                </a>
              ) : null}
              {socials.youtube ? (
                <a href={socials.youtube} target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" aria-label="YouTube" className="h-10 w-10 inline-flex items-center justify-center border border-ivory/25 hover:bg-ivory hover:text-charcoal transition-colors">
                  <Youtube className="h-4 w-4" strokeWidth={1.4} />
                </a>
              ) : null}
              {socials.pinterest ? (
                <a href={socials.pinterest} target="_blank" rel="noopener noreferrer" data-testid="footer-pinterest" aria-label="Pinterest" className="h-10 w-10 inline-flex items-center justify-center border border-ivory/25 hover:bg-ivory hover:text-charcoal transition-colors text-xs font-semibold">P</a>
              ) : null}
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="uppercase tracking-[0.25em] text-[10px] text-ivory/40 mb-4">Studios</div>
            <ul className="space-y-3 font-light text-ivory/80">
              {offices.map((o) => (
                <li key={o.city}>
                  <div className="text-ivory">{o.city}</div>
                  <div className="text-ivory/55 text-sm">{o.address}</div>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <div className="uppercase tracking-[0.25em] text-[10px] text-ivory/40 mb-4">Contact</div>
            <ul className="space-y-3 text-ivory/80 font-light">
              {footer?.phone ? <li><a href={`tel:${footer.phone}`} onClick={() => trackContact("phone", { source_section: "footer" })} className="hover:text-gold">{footer.phone}</a></li> : null}
              {footer?.email ? <li><a href={`mailto:${footer.email}`} onClick={() => trackContact("email", { source_section: "footer" })} className="hover:text-gold">{footer.email}</a></li> : null}
              {footer?.whatsapp_number ? (
                <li>
                  <a
                    href={`https://wa.me/${footer.whatsapp_number}?text=${encodeURIComponent(footer.whatsapp_message || "Hi Mostash")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackContact("whatsapp", { source_section: "footer" })}
                    className="hover:text-gold"
                  >
                    WhatsApp
                  </a>
                </li>
              ) : null}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-ivory/40 text-xs uppercase tracking-[0.25em]">
            © {new Date().getFullYear()} {brand?.name || "Weddings by Mostash"} — All rights reserved
          </p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-ivory/35 text-[10px] uppercase tracking-[0.3em] hover:text-gold transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
